import React from 'react';
import { sizeGuideClick } from '../../helpers/constants';
import analyticsHelper from '../../analytics/analytics';

export default function SizeGuideLink({
  hasSizeGuide, sizeGuideLinkText, setSizeGuideOpen,
}) {
  if (!hasSizeGuide) { return null; }

  const handleClick = () => {
    setSizeGuideOpen(true);
    analyticsHelper.handleProductAnalytics(sizeGuideClick);
  };

  return (
    <div className="size-guide-link-wrapper">
      <div onClick={handleClick} role="presentation" data-testid="link">
        {sizeGuideLinkText}
      </div>
    </div>
  );
}
